import { render, staticRenderFns } from "./headerB.vue?vue&type=template&id=0a502cb1&scoped=true"
import script from "./headerB.vue?vue&type=script&lang=js"
export * from "./headerB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a502cb1",
  null
  
)

export default component.exports